var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.component},[_c('div',{class:_vm.$style.image,style:({
      'background-image': ("url('" + _vm.image + "')"),
    })}),_c('span',{class:_vm.$style.name},[_vm._v(" "+_vm._s(_vm.getUser.name)+" ")]),_c('span',{class:_vm.$style.username},[_vm._v(" "+_vm._s(_vm.getUser.username)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }